import React from "react";
import PropTypes from "prop-types";

const DrawerHeader = ({children}) => (
  <div className={"DrawerHeader-Root"}>
    {children}
  </div>
);

DrawerHeader.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
};

export default DrawerHeader;